import { render, staticRenderFns } from "./ManagementAddContractorInfoAdditional.vue?vue&type=template&id=63820097&scoped=true"
import script from "./ManagementAddContractorInfoAdditional.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoAdditional.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAddContractorInfoAdditional.vue?vue&type=style&index=0&id=63820097&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63820097",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63820097')) {
      api.createRecord('63820097', component.options)
    } else {
      api.reload('63820097', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoAdditional.vue?vue&type=template&id=63820097&scoped=true", function () {
      api.rerender('63820097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoAdditional.vue"
export default component.exports